var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon Left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.2055 17.4523C13.0471 17.4523 12.8888 17.394 12.7638 17.269L7.33047 11.8356C6.44714 10.9523 6.44714 9.50231 7.33047 8.61898L12.7638 3.18564C13.0055 2.94398 13.4055 2.94398 13.6471 3.18564C13.8888 3.42731 13.8888 3.82731 13.6471 4.06898L8.2138 9.50231C7.8138 9.90231 7.8138 10.5523 8.2138 10.9523L13.6471 16.3856C13.8888 16.6273 13.8888 17.0273 13.6471 17.269C13.5221 17.3856 13.3638 17.4523 13.2055 17.4523Z",
    fill: "#1B75BC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeft);
export default __webpack_public_path__ + "static/media/IconLeft.b8e3149ad256ca7230dd38f9846da52f.svg";
export { ForwardRef as ReactComponent };